module.exports = __webpack_public_path__ + "static/media/notosans-bold-webfont.66953b97.woff";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/fonts/notosans-bold-webfont.woff
// module id = 1517
// module chunks = 0